import { SIZE_LIST_REQUEST, SIZE_LIST_SUCCESS, SIZE_LIST_ERROR } from "../actions/sizeList"

let initialState = {
    loading: false,
    data: null,
    sizeData: [],
    error: null
}

const sizeList = (state = initialState, action) => {
    switch (action.type) {
        case SIZE_LIST_REQUEST:
            return {
                ...state,
                loading: true
            }

        case SIZE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case SIZE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }

        default:
            return state;
    }
}

export default sizeList